import { Pipe, PipeTransform } from '@angular/core';

import { naturezaVendaSituacoes } from '../natureza-venda-situacao';

@Pipe({
    name: 'naturezaVendaSituacao'
})
export class NaturezaVendaSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = naturezaVendaSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return naturezaVendaSituacoes[index].nome;
        }
        return '';
    }
}
